<template>
  <div class="content">
    <div class="d-flex align-center h-100">
      <v-card class="mx-auto pa-10" elevation="8" width="400" max-width="448" rounded="lg">
        <v-card-title>
          <v-img class="mx-auto" max-width="228" src="@/assets/images/logo-wide.jpg" />
        </v-card-title>
        <v-card-text>
          <div class="text-center" v-if="process">
            <v-progress-circular class="py-5 ma-1" indeterminate :size="70" :width="5" color="green" />
            <div class="text-center text-h5">Validando Cuenta</div>
            <div>Por favor no cierres ni recargues esta página.</div>
          </div>
          <div class="text-center" v-if="output.success">
            <div class="text-h2">
              <v-icon color="green">mdi-check-circle-outline</v-icon>
            </div>
            <div class="text-h5">¡Cuenta activada!</div>
            <div>Ahora puedes iniciar sesión con tú cuenta.</div>
            <div>
              <v-btn class="my-5" block variant="tonal" color="blue" @click="$router.push({name: 'access'})">Iniciar Sesión</v-btn>
            </div>
          </div>
          <div class="text-center" v-if="output.error">
            <div class="text-h2">
              <v-icon color="red">mdi-close-circle-outline</v-icon>
            </div>
            <div class="text-h5">¡Error!</div>
            <div>La cuenta no se ha podido activar.</div>
            <div>{{ output.message }}</div>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>
<script setup>
  import axios from 'axios'
  import Params from "../models/params";
  import { ref, reactive, onMounted } from "vue";
  import { useRoute } from 'vue-router';
  
  const route = useRoute();

  const process = ref(true);
  const output = reactive({
    success: false,
    error: false,
    message: null
  });

  const params = ref(new Params)

  async function validate(){
    try {
      const token = route.params.token;
      const inscription = route.params.inscription;
      const frm = new FormData;
      frm.append("action", "validateaccount");
      frm.append("id", inscription);
      frm.append("token", token);
      const result = await eject(frm);
      process.value = false;
      if(result.status){
        output.success = true;
      }else{
        output.message = result.message;
        output.error = true;
      }
    } catch (err) {
      output.message = err.message;
      output.error = true;
    }
  }

  function eject(f){
    return new Promise((resolve) => {
      axios.post(params.value.controller + 'beneficiario.php',f)
      .then(res => {
        resolve(res.data)
      })
      .catch(() => {
        resolve(null)
      })
    })
  }

  onMounted(() => {
    validate();
  });
</script>